import { Directive, HostListener, Input } from '@angular/core';

/**
 * Directiva que permite únicamente la entrada de dígitos en un campo y limita
 * la cantidad máxima de caracteres según el valor de `maxDigits`.
 */
@Directive({
  selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirective {
  @Input() maxDigits: number = 0;
  constructor() { }

  /**
   * Bloquea las teclas no numéricas y la entrada que exceda el número máximo de dígitos permitido.
   * @param e - Evento de teclado que se evalúa y, en su caso, se cancela.
   */
  @HostListener('keypress', ['$event']) blockNumbers(e: KeyboardEvent) {
    var regexp = /^[0-9]+$/;
    const inputValue = (e.target as HTMLInputElement).value;

    if (!regexp.test(e.key) || inputValue.length > this.maxDigits) {
      e.preventDefault();
    }
  }
}
